export default "__VITE_ASSET__BSd5fov3__"